import ResourceService from "./resource.service";

class HistoryService extends ResourceService {
  static get resource() {
    return "history";
  }
}

export default HistoryService;